import script from "./AtomAccordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomAccordion.vue?vue&type=script&lang=ts&setup=true"

import "./AtomAccordion.vue?vue&type=style&index=0&id=8fb618d6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fb618d6"]])

export default __exports__